export default __webpack_public_path__ + "static/media/aboutlg.896eaa05.webp";